import React from 'react'
import { useParams } from 'react-router-dom'

import { InventoryShipment } from '@components/common/InventoryShipment/InventoryShipment'
import { useInventoryShipmentsQuery } from '@components/hooks/useInventoryShipmentsQuery'
import { ButtonClean } from '@fourthwall/components'
import { routing } from '@utils/routing'

import * as S from './InventoryShipmentSection.styled'

export const InventoryShipmentSection = () => {
  const { productId = '' } = useParams<'productId'>()
  const { inventoryShipmentsQuery } = useInventoryShipmentsQuery([{ offerId: productId }])

  if (!inventoryShipmentsQuery.data || inventoryShipmentsQuery.data.length === 0) {
    return null
  }

  return (
    <S.Container>
      <S.Head>
        <h4>Inventory shipments of this product</h4>
        <ButtonClean label="View all" to={routing.settings.shipping.self} />
      </S.Head>

      <S.Content>
        <InventoryShipment
          data={inventoryShipmentsQuery.data || []}
          isLoading={inventoryShipmentsQuery.isLoading}
        />
      </S.Content>
    </S.Container>
  )
}
